import {Icon, Layout} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, Text, TouchableOpacity} from 'react-native';
import {getImage} from '../../../helpers/general';
import {px} from '../../../utils';

const TeacherRow = ({data, onPress}) => {
  const {name, image} = data;

  return (
    <TouchableOpacity onPress={() => onPress(data)}>
      <Layout style={styles.container}>
        <Layout style={styles.rowContainer}>
          <Image
            source={{uri: getImage(image)}}
            resizeMode="contain"
            style={styles.personIcon}
          />
          <Text style={styles.name}>{name}</Text>
        </Layout>
        <Icon
          style={styles.arrowIcon}
          fill="black"
          name="arrow-ios-forward-outline"
        />
      </Layout>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: px(17),
    marginVertical: px(10),
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  name: {
    fontSize: px(16),
    marginLeft: px(10),
  },
  personIcon: {
    width: px(70),
    height: px(70),
    borderRadius: 50,
    backgroundColor: '#FFEDEF',
  },
  arrowIcon: {
    width: px(30),
    height: px(30),
  },
});

export default TeacherRow;
